import React from 'react'
import Index from '../views/dashboard/index'
// import { Switch, Route } from 'react-router-dom'
// user
import UserProfile from '../views/dashboard/app/user-profile';
import UserAdd from '../views/dashboard/app/user-add';
import UserList from '../views/dashboard/app/user-list';
// import userProfileEdit from '../views/dashboard/app/user-privacy-setting';
// widget
import Widgetbasic from '../views/dashboard/widget/widgetbasic';
import Widgetcard from '../views/dashboard/widget/widgetcard';
import Widgetchart from '../views/dashboard/widget/widgetchart';
// icon
import Solid from '../views/dashboard/icons/solid';
import Outline from '../views/dashboard/icons/outline';
import DualTone from '../views/dashboard/icons/dual-tone';
// Form
import FormElement from '../views/dashboard/from/form-element';
import FormValidation from '../views/dashboard/from/form-validation';
import FormWizard from '../views/dashboard/from/form-wizard';
// table
import BootstrapTable from '../views/dashboard/table/bootstrap-table';
import TableData from '../views/dashboard/table/table-data';

// map
import Vector from '../views/dashboard/maps/vector';
import Google from '../views/dashboard/maps/google';

//extra
// import PrivacyPolicy from '../views/dashboard/extra/privacy-policy';
// import TermsofService from '../views/dashboard/extra/terms-of-service';

//TransitionGroup
// import { TransitionGroup, CSSTransition } from "react-transition-group";
//Special Pages
import CategoryList from '../views/dashboard/CategoryPages/categorylist';

import AddCategory from '../views/dashboard/CategoryPages/add_category';

import SubCategorylist from '../views/dashboard/CategoryPages/Subcategorylist';
import AddSubcategory from '../views/dashboard/CategoryPages/Addsubcategory';
//admin
import Admin from '../views/dashboard/admin/admin';
import Default from '../layouts/dashboard/default';
import AddStyle from '../views/dashboard/CategoryPages/AddStyle';
import StlyeList from '../views/dashboard/CategoryPages/StlyeList';
import IconList from '../views/dashboard/Icons_pages/IconList';
import AddIcon from '../views/dashboard/Icons_pages/AddIcon';
import SignIn from '../views/dashboard/auth/sign-in';
import PrivateRoute from '../views/dashboard/auth/PrivateRoute';
import EditIcon from '../views/dashboard/Icons_pages/EditIcon';
import { Navigate } from 'react-router-dom';


export const DefaultRouter = [
    {
        path: '/frontend',
        element: <Default />,
        children: [

            {
                path: '/frontend/dashboard/category/category-list',
                element: <PrivateRoute element={<CategoryList />} />
            },
            {
                path: '/frontend/dashboard/category/add-category',
                element: <PrivateRoute element={<AddCategory />} />
            },
            {
                path: '/frontend/dashboard/category/subcategory-list',
                element: <PrivateRoute element={<SubCategorylist />} />
            },
            {
                path: '/frontend/dashboard/category/add-subcategory',
                element: <PrivateRoute element={<SubCategorylist />} />
            },
            {
                path: '/frontend/dashboard/category/style-list',
                element:<PrivateRoute element={<StlyeList />} />, 
            },
            {
                path: '/frontend/dashboard/category/add-style',
                element: <PrivateRoute element={<AddStyle />} />,
            },
            {
                path: '/frontend/dashboard/icon/icon-list',
                element: <PrivateRoute element={<IconList />} />
            },
            {
                path: '/frontend/dashboard/icon/add-icon',
                element: <PrivateRoute element={<AddIcon />} />
            },
            {
                path:'/frontend/dashboard/icon/edit-icon/:icon_id',
                element: <PrivateRoute element={<EditIcon />} />
            },
            
        ]
    },
    {
        path: '/frontend/iconfinder/login',
        element: <SignIn />
    },
    {
        path: '/*',
        element: <Navigate to="/frontend/iconfinder/login" replace />,
    },
]
